import { render, staticRenderFns } from "./RecentNews.vue?vue&type=template&id=20c9c544&scoped=true"
import script from "./RecentNews.vue?vue&type=script&lang=js"
export * from "./RecentNews.vue?vue&type=script&lang=js"
import style0 from "./RecentNews.vue?vue&type=style&index=0&id=20c9c544&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c9c544",
  null
  
)

export default component.exports